import { styled } from "styled-components";

export const FloatingBanner = styled.div`
  position: fixed;
  bottom: 40px;
  right: 40px;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 196px;
    height: 68px;
    background-color: #171717;
    border: 1px solid #efefef;
    box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 48px;
    p {
      font-size: 20px;
      font-weight: bold;
      &.active {
        color: #fee500;
      }
      &.default {
        color: #fbfbfb;
      }
    }
    i {
      width: 20px;
      height: 20px;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  @media all and (max-width: 900px) {
    bottom: 20px;
    right: 20px;
    a {
      width: 154px;
      height: 56px;
      p {
        font-size: 16px;
      }
      i {
        width: 16px;
        height: 16px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    bottom: 2.604vw;
    right: 2.604vw;
    a {
      width: 27.344vw;
      height: 9.115vw;
      gap: 1.823vw;
      p {
        font-size: 3.385vw;
      }
      i {
        width: 2.865vw;
        height: 2.865vw;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`;
